import { Box, Typography, useTheme } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import DoneRoundedIcon from "@mui/icons-material/DoneRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import CustomButton from "../../../components/CustomButton";
import { useTranslation } from "react-i18next";
import { PricingPlanUsa } from "./pricingPlansUsa";
import { useStyles } from "../styles/PlanCard.styles";

interface PlanCardUsaProps {
  plan: PricingPlanUsa;
  isSelected: boolean;
  isFavorite: boolean;
  isLoading: boolean;
  buttonText: string;
  onButtonClick: () => void;
}

const PlanCardUsa: React.FC<PlanCardUsaProps> = ({
  plan,
  isSelected,
  isFavorite,
  isLoading,
  buttonText,
  onButtonClick,
}) => {
  const theme = useTheme();
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={classes.planCardContainer}>
      <Box style={{ height: 17, marginTop: 16, marginBottom: 3 }}>
        {isFavorite && (
          <Typography className={classes.favoriteText}>
            {t("subscriptions.tarifs.mostFavorite")}
          </Typography>
        )}
      </Box>
      <Box className={classes.planTypeContainer}>
        <Box className={classes.starIconBox}>
          {isFavorite && (
            <StarIcon
              style={{
                color: theme.palette.main.secondary.o,
                fontSize: 24,
              }}
            />
          )}
        </Box>
        <Typography className={classes.planTypeText}>
          {t("subscriptions.tarifs." + plan.type + ".title")}
        </Typography>
        <Box className={classes.starIconBox}></Box>
      </Box>
      <Typography
        style={{
          textAlign: "center",
          fontSize: 35,
          fontWeight: "700",
          color: theme.palette.natural.t,
        }}
      >
        {plan.apiPrice !== undefined
          ? `${(plan.periodOfTime === "year"
              ? plan.apiPrice / 100 / 12
              : plan.apiPrice / 100
            ).toFixed(2)}`
          : t(
              "subscriptions.tarifs." +
                plan.type +
                (plan.periodOfTime === "year" ? ".priceYearly" : ".priceMonthly"),
            )}
      </Typography>
      <Typography
        style={{
          textAlign: "center",
          fontSize: 16,
          fontWeight: "400",
          color: theme.palette.natural.t2,
        }}
      >
        {plan.periodOfTime === "year"
          ? t("subscriptions.tarifs.yearly")
          : t("subscriptions.tarifs.monthly")}
      </Typography>
      <Typography className={classes.numberOfShowsText}>
        {t("subscriptions.tarifs.viewsPerMonth")}
      </Typography>
      <Typography className={classes.numberOfNotificationText}>
        {plan.numberOfNotifications}
      </Typography>
      <Box className={classes.listContainer} style={{ marginTop: 20 }}>
        <Box className={classes.listItem}>
          <Box className={classes.iconContainer}>
            <DoneRoundedIcon style={{ color: theme.palette.main.accent.o }} />
          </Box>
          <Typography className={classes.listItemText}>{`${t(
            "subscriptions.tarifs.to",
          )} ${plan.numberOfNotifications.toLocaleString()} ${t(
            "subscriptions.tarifs.monthlyViews",
          )} `}</Typography>
        </Box>
        {plan.benefits.map((b, index) => (
          <Box key={index} className={classes.listItem}>
            <Box className={classes.iconContainer}>
              <DoneRoundedIcon
                style={{ color: theme.palette.main.accent.o }}
              />
            </Box>
            <Typography className={classes.listItemText}>
              {t("subscriptions.tarifs." + b)}
            </Typography>
          </Box>
        ))}
      </Box>
      {plan.disadvantages && plan.disadvantages.length > 0 && (
        <Box className={classes.listContainer}>
          {plan.disadvantages.map((d, index) => (
            <Box className={classes.listItem} key={index}>
              <Box className={classes.closeIconContainer}>
                <CloseRoundedIcon style={{ color: theme.palette.natural.t3 }} />
              </Box>
              <Typography className={classes.listItemText}>
                {t("subscriptions.tarifs." + d) +
                  (d === "unlimitedWebsites"
                    ? " " + t("subscriptions.tarifs.onlyOneWebsite")
                    : "")}
              </Typography>
            </Box>
          ))}
        </Box>
      )}
      <Box style={{ flex: 1 }} />
      <Box className={classes.planButtonContainer}>
        {isSelected ? (
          <Box
            style={{
              height: 44,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <DoneRoundedIcon style={{ color: theme.palette.main.primary.o }} />
            <Typography
              style={{
                color: theme.palette.main.primary.o,
                fontSize: 16,
                marginLeft: 10,
              }}
            >
              {t("subscriptions.tarifs.selected")}
            </Typography>
          </Box>
        ) : (
          <CustomButton
            size='medium'
            style={{
              paddingLeft: theme.spacing(1),
              paddingRight: theme.spacing(1),
            }}
            title={buttonText}
            isLoading={isLoading}
            isDisabled={isLoading}
            onClick={onButtonClick}
          />
        )}
      </Box>
    </Box>
  );
};

export default PlanCardUsa;
